// Light/dark ("night mode") theme. The whole design system is CSS-variable
// based (see globals.css), so switching themes is just flipping a `data-theme`
// attribute on <html> — every token-driven colour follows.
//
// The theme FOLLOWS THE OS appearance (prefers-color-scheme), live: set your
// Mac to Dark (or Auto, which goes dark in the evening) and the portal follows
// without any manual toggle. initTheme() runs before React renders (main.tsx)
// so there's no flash of the wrong theme on load.

function osPrefersDark(): boolean {
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false;
}

function applyTheme(dark: boolean): void {
  document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light');
}

/** Apply the OS theme now, and keep following it if the OS appearance changes. */
export function initTheme(): void {
  applyTheme(osPrefersDark());
  window
    .matchMedia?.('(prefers-color-scheme: dark)')
    .addEventListener('change', (e) => applyTheme(e.matches));
}
